


























    import { Watch, RightHelper, BaseTLTableComponent, AxiosResponse, Vue, Component, LoginHistoryService, LoginHistoryFilter, Prop, tlISODateTimeToLocalNoSecondsString, tlPrepareForFilter } from "../../../Infrastructure/CorBase/CoreBase";



	@Component
	export default class LoginHistoryList extends BaseTLTableComponent {

		@Prop({ type: Boolean, required: false, default: false }) isUserDetail?: boolean;
		@Prop({ type: Boolean, required: false, default: false }) changeBackgroundColor?: boolean; //změna barvy pozadí jako formulář
		@Prop({ type: Boolean, required: false, default: false }) hideLoginFilter?: boolean;
		@Prop({ type: Number, required: false, default: 0 }) idUser?: number;
		@Prop({ type: String, required: false, default: 'history' }) nameHistory?: string; //jednaznacne jmeno (když není určeno, tak se přenaší do další tabulky)


		loginHistoryService: LoginHistoryService = new LoginHistoryService();
		formData = {
			id: null

		};

		goToUserDetail(item: any) {
			if (item.identif == "user") {
				this.$router.push({ name: 'UserDetail', params: { id: item.id }, query: { id: item.id } });
			}
			else {
                this.$router.push({ name: 'TenantDetail', params: { id: item.id }, query: { id: item.id } });
			}
        }

		setFields() {
			this.fields = [];
			//this.fields.push({ key: 'id', label:'id', trans: 'id', sortable: true, sortDirection: 'asc', class: 'text-center' });

			if (this.hideLoginFilter == false) {
			//	this.fields.push({ key: 'loginUser', label: this.$t('loginHistoryList.fieldLogin'), trans: 'loginHistoryList.fieldLogin', sortable: true, sortDirection: 'asc', class: 'text-center' });
                this.fields.push({ key: 'userLink', label: this.$t('loginHistoryList.fieldLogin'), trans: 'loginHistoryList.fieldLogin', sortable: true, sortDirection: 'asc', class: 'text-left', design: 'detailLink', thClass: 'firstColumnMichael' });          
			}
			if (this.isSuperUser) {
                this.fields.push({ key: 'tenantLink', label: this.$t('loginHistoryList.fieldTenant'), trans: 'loginHistoryList.fieldTenant', sortable: true, sortDirection: 'asc', class: 'text-left', design: 'detailLink' });
			}
            this.fields.push({ key: 'loginDate', label: this.$t('loginHistoryList.fieldDate'), trans: 'loginHistoryList.fieldDate', sortable: true, sortDirection: 'asc', class: 'text-left', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) });
            this.fields.push({ key: 'idStateNavigationName', label: this.$t('loginHistoryList.fieldState'), trans: 'loginHistoryList.fieldState', sortable: true, sortDirection: 'asc', class: 'text-left' });
            this.fields.push({ key: 'ipaddressText', label: this.$t('loginHistoryList.fieldIP'), trans: 'loginHistoryList.fieldIP', sortable: true, sortDirection: 'asc', class: 'text-left' });
		};

		setfilters(value: any) {
            if (value != null && value[0].lang == this.filters[0].lang) {
				this.filters = value;
			}
			else {
				if (this.hideLoginFilter == false) {
	
					this.filters = [
						{ key: 'userLink', label: this.$t('loginHistoryList.filterLogin'), trans: 'loginHistoryList.filterLogin', selected: false, value: null, type: 'text', lang: this.$store.state.currentLanguage, isDetail: true },
                        { key: 'tenantLink', label: this.$t('loginHistoryList.fieldTenant'), trans: 'loginHistoryList.fieldTenant', selected: false, value: null, type: 'text', lang: this.$store.state.currentLanguage, isDetail: true },
						{ key: 'loginDate2', label: 'Datum přihlášení od', selected: false, value: null, type: 'datetime', moreThan: true, lang: this.$store.state.currentLanguage, refItem: 'loginDate' },
						{ key: 'loginDate3', label: 'Datum přihlášení do', selected: false, value: null, type: 'datetime', moreThan: false, refItem: 'loginDate' },
						{ key: 'ipaddressText', label: this.$t('loginHistoryList.filterIP'), trans: 'loginHistoryList.filterIP', selected: false, value: null, type: 'text' }];

                    var taskStateEnums = { key: 'ENU_COR_LoginHistory_State', label: 'AAA doplnit', selected: true, value: 'AAA doplnit', type: 'text', group: true, groupId: 'idStateNavigationIdentifier', groupName: this.$t('global.filterNotShowType').toString(), headName: this.$t('loginHistoryList.fieldState'), trans: 'loginHistoryList.fieldState', isNegative: true };
                    super.loadFiltersEnum(taskStateEnums);					
              }
				else {
                    this.filters = [
                        { key: 'loginDate2', label: 'Datum přihlášení od', selected: false, value: null, type: 'datetime', moreThan: true, lang: this.$store.state.currentLanguage, refItem: 'loginDate' },
                        { key: 'loginDate3', label: 'Datum přihlášení do', selected: false, value: null, type: 'datetime', moreThan: false, refItem: 'loginDate' },

                    { key: 'idState', label: 'Stav', selected: false, value: null, type: 'text', enum: 'ENU_COR_LoginHistory_State', useEnum: true },
						{ key: 'ipaddressText', label: this.$t('loginHistoryList.filterIP'), trans: 'loginHistoryList.filterIP', selected: false, value: null, type: 'text' }];

                    var taskStateEnums = { key: 'ENU_COR_LoginHistory_State', label: 'AAA doplnit', selected: true, value: 'AAA doplnit', type: 'text', group: true, groupId: 'idStateNavigationIdentifier', groupName: this.$t('global.filterNotShowType').toString(), headName: this.$t('loginHistoryList.fieldState'), trans: 'loginHistoryList.fieldState', isNegative: true };
                    super.loadFiltersEnum(taskStateEnums);
				}				


			}
		}

		prepareItems(items: any[]) {
			for (var i = 0; i < items.length; i++) {
				items[i].loginDate2 = (items[i].loginDate);
				items[i].loginDate3 = (items[i].loginDate);
			}
			this.isBusy = false;
		}

		loginFilterName() {
			return this.hideLoginFilter ? "" : "loginUser";
		}

	//	mainDescription: string = "Historie přihlášení uživatele";


		created() {
			super.initializeRights(undefined, undefined, 'COR_LoginHistory_Read', undefined);
			super.created();
		};

		fetchDataFromServer(): Promise<AxiosResponse<any>> {		
			let idUser = this.getIdUser();
			let loginFilter: LoginHistoryFilter = new LoginHistoryFilter(idUser, null, null, this.$store.state.idTenant, RightHelper.currentUserIsSuperUser());
			return this.loginHistoryService.getAllByFilter(loginFilter);
		}

        //zatím nepotrebujeme
        fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
            return this.fetchDataFromServer();
        }

        refreshItems(items: any[], refreshData: any[]) {
            return items;
        }

		getIdUser(): number | null {			
			if (this.idUser && this.idUser > 0) {
				return this.idUser;
			}			
			return null;
		}

		get inputClass() {
			return {
				"backGroundColorForm": this.changeBackgroundColor == true
			};
		}

		setUserId(id: number) {
			this.idUser = id;
		}

		loadFilters(value: any) { super.loadFilters(value); };
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); };
		deleteClick(elementId: any) { super.deleteClick(elementId); }


        //@ts-ignore
        @Watch('$store.state.currentLanguage')
        changeFieldsAfterChangeLanguageD(value: boolean, oldValue: boolean) {
            this.setfilters(null);
        }
	}
